import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  const [params] = useSearchParams();
  const orderId = params.get("order_id");
  return (
    <div data-testid="payment-cancel-page" className="mx-auto max-w-2xl px-4 sm:px-6 py-20">
      <div className="border border-white/10 bg-zinc-950 p-8 text-center">
        <XCircle className="h-12 w-12 text-yellow-400 mx-auto mb-4"/>
        <h1 className="font-display text-2xl mb-2">Payment cancelled</h1>
        <p className="text-white/60 text-sm mb-6">Your order is still saved. You can retry payment or pick a different method.</p>
        <div className="flex gap-3 justify-center">
          <Button asChild className="bg-blue-600 hover:bg-blue-500 rounded-none">
            <Link to="/checkout">Try again</Link>
          </Button>
          {orderId && (
            <Button asChild variant="outline" className="border-white/20 bg-transparent hover:bg-white/5 rounded-none">
              <Link to={`/order/${orderId}`}>View order</Link>
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
